// @ts-nocheck
import {useNavigate} from "react-router-dom";
// Hover logos (sports-carousel dark versions)
import LogoChampionHover from "../../../../../assets/images/sports-carousel/champion-league-dark.svg";
import LogoLaligaHover from "../../../../../assets/images/sports-carousel/laliga-dark.svg";
import LogoLvbpHover from "../../../../../assets/images/sports-carousel/lvbp-dark.svg";
import LogoNbaHover from "../../../../../assets/images/sports-carousel/nba-dark.svg";
import LogoNflHover from "../../../../../assets/images/sports-carousel/nfl-dark.svg";
// Default logos (sports-section)
import LogoChampion from "../../../../../assets/images/sports-section/champion-league.svg";
import LogoLaliga from "../../../../../assets/images/sports-section/laliga.svg";
import LogoLvbp from "../../../../../assets/images/sports-section/lvbp.svg";
import LogoNba from "../../../../../assets/images/sports-section/nba.svg";
import LogoNfl from "../../../../../assets/images/sports-section/nfl.svg";
// Left image
import SportsImg from "../../../../../assets/images/sports-section/sports-bg.webp";
import {useAuthStore} from "../../../../../store/useAuth.store";

const sportshomeSectionCls =
  "section-bleed relative overflow-hidden flex flex-row items-center justify-center gap-[38px] py-10 px-[clamp(32px,5vw,80px)] box-border bg-[var(--color-surface-2)] border-b border-[var(--color-border)] max-[900px]:flex-col max-[900px]:py-8 max-[900px]:px-4 max-[900px]:gap-6";
const sportshomeLeftCls =
  "flex items-center justify-center flex-shrink-0 rounded-[var(--radius-md)] overflow-hidden relative shadow-[var(--shadow-md)] max-[900px]:ml-0";
const sportshomeCharacterCls =
  "w-[483px] h-[303px] rounded-[var(--radius-md)] box-border object-cover block opacity-100 max-[900px]:w-full max-[900px]:max-w-[var(--size-80)] max-[900px]:h-[220px] max-[900px]:py-1 max-[900px]:px-4";
const sportshomeCharOverlayCls = "absolute inset-0 flex flex-col items-center justify-center gap-2.5 z-[var(--z-base)]";
const sportshomeCharTitleCls =
  "font-[var(--font-family)] font-extrabold text-[var(--font-h1)] leading-8 text-[var(--color-text)] [text-shadow:var(--shadow-md)] w-[150px] h-[var(--size-11-25)] flex items-center justify-center py-1.5 px-2.5 rounded-[var(--radius-pill)] box-border";
const sportshomeCharBtnCls =
  "w-[152px] h-11 flex items-center justify-center px-4 rounded-[var(--radius-pill)] border-0 cursor-pointer bg-[var(--color-primary)] font-[var(--font-family)] font-bold text-sm text-[var(--color-text-inverse)] box-border transition-[background-color,transform] duration-[var(--transition-fast)] hover:bg-[var(--color-primary-hover)] hover:-translate-y-0.5";
const sportshomeRightCls = "flex flex-col items-start justify-center gap-7 max-[900px]:items-center";
const sportshomeSubtitleCls =
  "font-[var(--font-family)] font-normal text-xl leading-[var(--leading-lg)] tracking-[0.01em] text-[var(--color-text)] mx-auto max-[900px]:text-sm max-[900px]:leading-5 max-[900px]:text-center";
const sportshomeLogosRowCls =
  "flex flex-row items-center justify-start gap-[clamp(20px,5vw,70px)] flex-wrap max-[900px]:justify-center max-[900px]:gap-4";
const sportshomeLogoCardCls =
  "group cursor-pointer rounded-[var(--radius-lg)] relative flex items-center justify-center transition-[filter,transform] duration-300 [&_img]:block [&_img]:h-[var(--size-25)] [&_img]:max-w-[140px] [&_img]:object-contain hover:-translate-y-[3px] hover:[filter:drop-shadow(0_0_8px_var(--color-danger))_drop-shadow(0_0_20px_rgba(255,12,62,0.7))] max-[900px]:[&_img]:h-[var(--size-12-5)] max-[900px]:[&_img]:max-w-[var(--size-22-5)]";
const sportshomeLogoDefaultCls = "opacity-100 transition-opacity duration-300 group-hover:opacity-0";
const sportshomeLogoHoverCls =
  "absolute inset-0 w-full h-full object-contain opacity-0 transition-opacity duration-300 group-hover:opacity-100";

const logos = [
  {
    id: "champion",
    src: LogoChampion,
    hover: LogoChampionHover,
    alt: "Champion League",
  },
  {id: "laliga", src: LogoLaliga, hover: LogoLaligaHover, alt: "La Liga"},
  {id: "lvbp", src: LogoLvbp, hover: LogoLvbpHover, alt: "LVBP"},
  {id: "nfl", src: LogoNfl, hover: LogoNflHover, alt: "NFL"},
  {id: "nba", src: LogoNba, hover: LogoNbaHover, alt: "NBA"},
];

const SportsDisplay = () => {
  const navigate = useNavigate();
  const authStatus = useAuthStore(state => state.authStatus);
  const handleShowAuthModal = useAuthStore(state => state.handleShowAuthModal);

  return (
    <div className={sportshomeSectionCls}>
      {/* Left: sports image with title + button overlay */}
      <div className={sportshomeLeftCls}>
        <img
          src={SportsImg}
          alt="Sports background"
          className={sportshomeCharacterCls}
        />
        <div className={sportshomeCharOverlayCls}>
          <span className={sportshomeCharTitleCls}>Deportes</span>
          <button
            className={sportshomeCharBtnCls}
            type="button"
            onClick={() => (authStatus === "authenticated" ? navigate("/sports") : handleShowAuthModal())}
          >
            Ir a todos
          </button>
        </div>
      </div>

      {/* Right: subtitle + logos row */}
      <div className={sportshomeRightCls}>
        <p className={sportshomeSubtitleCls}>Juega donde juegan los profesionales</p>
        <div className={sportshomeLogosRowCls}>
          {logos.map(logo => (
            <div
              key={logo.id}
              className={sportshomeLogoCardCls}
              onClick={() => (authStatus === "authenticated" ? navigate("/sports") : handleShowAuthModal())}
            >
              <img
                src={logo.src}
                alt={logo.alt}
                className={sportshomeLogoDefaultCls}
              />
              <img
                src={logo.hover}
                alt={`${logo.alt} hover`}
                className={sportshomeLogoHoverCls}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SportsDisplay;
